var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('reorderable-list',{attrs:{"config":Object.assign({}, _vm.config,
		{options:_vm.value}),"size":_vm.size}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }